'use client';

import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { login } from '@/api/auth';
import { useTranslation } from '@/i18n/client';
import { isLoggedInSet } from '@/store/auth';
import { WithLang } from '@/types/general';

import { AuthPopupKeys, AuthProps } from './auth.types';
import { AuthResponse } from './AuthResponse';

interface LoginFormValues {
    email: string;
    password: string;
}

export const Login = (props: WithLang<AuthProps>) => {
    const dispatch = useDispatch();

    const { t } = useTranslation(props.lang, 'auth');

    const [isResponseSuccess, setIsResponseSuccess] = useState<null | boolean>(null);

    const {
        register,
        handleSubmit,
        formState: { isValid },
    } = useForm<LoginFormValues>();

    const onSubmit = async (data: LoginFormValues) => {
        const request = await login({ ...data });

        if (request.errors) {
            setIsResponseSuccess(false);
            // setResponseMessage(request.errors[0].message);
        } else {
            dispatch(isLoggedInSet(true));
            props.onClose();
        }
    };

    const responseContent = isResponseSuccess
        ? {
              title: t('titles.login'),
              message: '',
          }
        : {
              title: t('messages.notFound'),
              message: '',
          };

    return isResponseSuccess === null ? (
        <>
            <p className="text-2xl">{t('titles.login')}</p>
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-y-4 border-b border-opacity-30 pb-6">
                <input
                    {...register('email', { required: true })}
                    className="input-primary"
                    placeholder={t('placeholders.email')}
                />
                <input
                    {...register('password', { required: true })}
                    className="input-primary"
                    placeholder={t('placeholders.password')}
                    type="password"
                />
                <button
                    type="button"
                    onClick={() => props.onRedirect(AuthPopupKeys.REFRESH)}
                    className="self-end text-sm"
                >
                    {t('buttons.forgotPassword')}
                </button>
                <button
                    type="submit"
                    disabled={!isValid}
                    onSubmit={handleSubmit(onSubmit)}
                    className="btn-accent mt-4 py-2 text-base font-semibold"
                >
                    {t('buttons.loginShort')}
                </button>
            </form>
            {/*<div className="mx-auto flex w-full flex-col items-stretch justify-center gap-x-2 gap-y-3 xs:w-5/6 sm:flex-row sm:items-center">
                <p className="xs: text-center text-sm">{t('common.noAccount')}</p>
                <button
                    type="button"
                    onClick={() => props.onRedirect(AuthPopupKeys.signup)}
                    className="btn-primary border-accent text-sm md:border-solid"
                >
                    {t('buttons.signup')}
                </button>
            </div>*/}
        </>
    ) : (
        <AuthResponse
            onClick={() => setIsResponseSuccess(null)}
            lang={props.lang}
            onRedirect={(key) => props.onRedirect(key)}
            onClose={props.onClose}
            responseContent={responseContent}
            isSuccess={isResponseSuccess}
        />
    );
};
